<template>
  <div>
    <c-table
      ref="applyTable"
      title="장비 대여신청 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      selection="multiple"
      rowKey="heaClosedSpaceEquipmentGiveItemId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="선택" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'closedSpaceEquipApplyPop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          heaClosedSpaceEquipmentGiveId: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      searchParam: {
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'equipmentTypeName',
            field: 'equipmentTypeName',
            label: '장비종류',
            style: 'width:100px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'equipmentName',
            field: 'equipmentName',
            label: '장비명',
            style: 'width:60px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'equipmentNumber',
            field: 'equipmentNumber',
            label: '신청수량',
            style: 'width:60px',
            align: 'right',
            sortable: false,
          },
          {
            name: 'requestDate',
            field: 'requestDate',
            label: '신청일',
            style: 'width:80px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'rentPeriod',
            field: 'rentPeriod',
            label: '대여예정기간',
            style: 'width:200px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'remark',
            field: 'remark',
            label: 'LBLREMARK',
            align: 'left',
            style: 'width:250px',
            sortable: false,
          },
        ],
        data: [],
        height: '450px'
      },
      //drinkStockItems: [],
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.cse.gives.detail.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      if (this.popupParam.heaClosedSpaceEquipmentGiveId) {
        this.$http.url = this.$format(this.listUrl, this.popupParam.heaClosedSpaceEquipmentGiveId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = _result.data.closedSpaceEquipmentGiveItemModels;
          if (this.grid.data && this.grid.data.length > 0) {
            this.$_.forEach(this.grid.data, item => {
              item.rentPeriod = [item.rentStartDate, item.rentEndDate]
            })
          }
        },);
      }
      },
    select() {
      let selectData = this.$refs['applyTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '신청 목록을 선택하세요.', 
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
